export const MAX_FILE_SIZE: number = 25 * 1024 * 1024;

export const MAX_FILE_UPLOADS: number = 40;
